import React from "react";
import App from "../Layouts/AppLayout";
import { Card, Section, Button } from "../Components";
import { FAQ, Security, TestimonialSlider } from "../Components/PageSections";

export default function Welcome() {
  const counter = [
    { name: 'Active Users', value: '40,000+' },
    { name: 'Active Sellers', value: '12,000+' },
    { name: 'Transaction Success', value: '99.99%' },
    { name: 'Customer Delight', value: '98%' },
  ];

  const flow = [
    {
      number: 1,
      head: 'Agreement Between Buyer and Seller',
      body: 'Seller uploads items. Buyer offers to buy the item and seller confirms the item is available in stock.',
      image: 'flow-buyer-seller.png',
      arrow: 'flow-line-left.png',
    },
    {
      number: 2,
      head: 'Buyer Secure Transactions Via SecurePay',
      body: 'The buyer transfers funds via POD SecurePay, where their funds are secured until the goods are delivered.',
      image: 'flow-secure-pay.png',
      arrow: 'flow-line-right.png',
    },
    {
      number: 3,
      head: 'Goods Shipped',
      body: 'Our logistics partner picks up the item from the seller and delivers to the buyer providing tracking information for both buyer and seller.',
      image: 'flow-goods-shipped.png',
      arrow: 'flow-line-left.png',
    },
    {
      number: 4,
      head: 'Delivery Confirmation',
      body: 'POD SecurePay automatically knows when the goods have been delivered. Buyer can confirm and pay seller immediately or we pay seller in 24 hours.',
      image: 'flow-confim-delivery.png',
    },
  ];

  const [faqs, setFaqs] = React.useState([]);

  React.useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await fetch('/help-center-data/buyer');
        const data = await response.json();
        setFaqs(data);
      } catch (e) { }
    };

    fetchFaqs();
  }, []);

  const FlowCard = ({ number, head, body, image, arrow }) => {
    const even = number % 2 === 1;
    return (
      <>
        <div className="tw-grid tw-gap-4 md:tw-grid-cols-2 md:tw-gap-8">
          <div className={`md:tw-col-span-1 ${even ? 'md:tw-order-first' : 'md:tw-order-last'} tw-flex tw-flex-col md:tw-flex-row md:tw-items-center`}>
            <div className="tw-flex tw-flex-col tw-gap-4 md:tw-flex-row md:tw-gap-8">
              <div className="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-secondary tw-font-bold tw-text-white from40-72">
                {number}
              </div>
              <div className="md:tw-w-fit">
                <h3 className="tw-text-black">{head}</h3>
                <p>{body}</p>
              </div>
            </div>
          </div>
          <div className="md:tw-col-span-1">
            <img loading="lazy" src={`/assets/images/${image}`} alt="POD Flow" className="tw-max-w-full" />
          </div>
        </div>

        {arrow && (
          <div className="tw-m-auto tw-my-4 tw-flex tw-justify-center tw-sm:max-w-lg md:tw-my-8 lg:tw-max-w-3xl">
            <img
              src={`/assets/images/${arrow}`}
              alt="POD Flow"
              className="tw-hidden md:tw-block"
            />
          </div>
        )}
      </>
    );
  };

  return (
    <App>
      <div className="tw-relative">
        <Section
          pad={false}
          className="tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-4 md:tw-gap-8 lg:tw-flex-row"
        >
          <div className="tw-space-y-8">
            <h1 className="h1-head">
              The fastest, most trusted way to buy and sell online.
            </h1>
            <p>Complete transactions anywhere online with confidence.</p>

            <div className="tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-bg-secondary tw-p-2 tw-text-white md:tw-inline-flex md:tw-gap-3">
              <img
                src="/assets/images/join-pod.png"
                alt="Join"
                className="join-pod"
              />
              <p className="tw-flex-1 !tw-text-xs md:tw-text-base !tw-font-bold md:tw-mr-2">
                Join over 40,000 people trusting POD
              </p>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="size-20px"
              >
                <path
                  d="M9.9974 18.3346C14.5998 18.3346 18.3307 14.6037 18.3307 10.0013C18.3307 5.39893 14.5998 1.66797 9.9974 1.66797C5.39502 1.66797 1.66406 5.39893 1.66406 10.0013C1.66406 14.6037 5.39502 18.3346 9.9974 18.3346Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.95312 12.9419L11.8865 10.0003L8.95312 7.05859"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>

          <div className="tw-z-10 tw-col-span-1">
            <img
              src="/assets/images/fococlipping.png"
              alt="POD: The fastest, most trusted way to buy and sell online."
              className="tw-z-10 tw-h-auto tw-min-w-full fococlipping tw-max-w-full"
            />
          </div>
        </Section>

        <img
          loading="lazy"
          src="/assets/brand/pod-bg-logo-left.png"
          alt="PayOnDelivery"
          className="tw-absolute tw-bottom-0 tw-right-0 tw-z-0 tw-h-auto tw-max-h-full tw-max-w-full md:tw-bottom-4 fococlipping"
        />
      </div>

      <div className="tw-bg-primary">
        <Section>
          <div className="tw-grid tw-grid-cols-2 tw-gap-8 !tw-divide-x-[0.5px] !tw-divide-gray-100 md:tw-grid-cols-4 md:tw-gap-4">
            {counter.map((item, index) => (
              <div key={index} className="tw-text-center">
                <h4 className="tw-font-bold tw-text-white">{item.value}</h4>
                <p className="tw-mt-4 tw-font-light tw-text-white">{item.name}</p>
              </div>
            ))}
          </div>
        </Section>
      </div>

      <Section className="tw-grid tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-5 md:tw-gap-8">
        <div className="tw-col-span-2 tw-flex tw-flex-col tw-space-y-4 md:tw-space-y-8">
          <h2 className="tw-hidden md:tw-block tw-text-black">
            Why choose PayOnDelivery?
          </h2>

          <Card className="tw-grid tw-flex-1 tw-gap-4 lg:tw-gap-8" style={{ background: '#EEECFF' }}>
            <div>
              <h3 className="tw-text-black">Safe Transactions</h3>
              <p>
                Your funds are protected until goods are
                delivered and validated, giving both buyers and
                sellers peace of mind.
              </p>
            </div>

            <Card className="tw-flex tw-items-center tw-justify-center" style={{ background: '#D8D3FF' }}>
              <img
                loading="lazy"
                src="/assets/images/pod-shield-secondary.png"
                alt="Safe Transactions"
                height={200}
                width={200}
                className="size-200px"
              />
            </Card>
          </Card>
        </div>

        <div className="tw-col-span-3 tw-space-y-4 lg:tw-space-y-8">
          <Card className="tw-grid tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-2 lg:tw-gap-8" style={{ background: '#EEFFF7' }}>
            <div>
              <h3 className="tw-text-black">Delivery Integration</h3>
              <p>
                POD SecurePay automation makes sure you don't
                pay until your item is delivered. Seller's
                payment is guaranteed.
              </p>
            </div>

            <Card className="tw-flex tw-items-center tw-justify-center" style={{ background: '#A3DBC0' }}>
              <img
                loading="lazy"
                src="/assets/images/delivery-bike.png"
                alt="Delivery Integration"
                height={200}
                width={200}
                className="size-200px"
              />
            </Card>
          </Card>

          <Card className="tw-grid tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-2 lg:tw-gap-8" style={{ background: '#FFF8EE' }}>
            <div>
              <h3 className="tw-text-black">POD SecurePay</h3>
              <p>
                Customer security and trust is built into our
                product. We remove the the of the fear of "what
                I ordered, vs what I got", Customer trust = More referrals = More sales.
              </p>
            </div>

            <Card className="tw-flex tw-items-center tw-justify-center" style={{ background: '#FBDEB4' }}>
              <img
                loading="lazy"
                src="/assets/images/money.png"
                alt="POD Securepay"
                height={200}
                width={200}
                className="size-200px"
              />
            </Card>
          </Card>
        </div>
      </Section>

      <Section>
        <div className="tw-mb-4 tw-block md:tw-mb-8 md:tw-flex md:tw-items-center md:tw-gap-8">
          <h2 className="tw-text-black">The POD transaction process</h2>
          {/*<p>*/}
          {/*  The whole journey of buying and selling on POD in*/}
          {/*  summary. <br />- How it Works*/}
          {/*</p>*/}
        </div>

        <Card className="tw-border tw-border-secondary" style={{
          border: '1px solid #6d60f6',
        }}>
          {flow.map((item, index) => (
            <FlowCard key={index} {...item} />
          ))}
        </Card>
      </Section>

      <div className="tw-bg-primary">
        <Section pad={false} className="tw-py-8 md:tw-py-32">
          <h2 className="!tw-mb-8 tw-text-center md:!tw-mb-16 tw-text-white">Pricing</h2>

          <div className="tw-grid tw-gap-4 md:tw-grid-cols-2 md:tw-gap-8">
            <Card className="tw-space-y-4 !tw-border !tw-border-solid md:tw-space-y-8 tw-text-white" style={{
              border: '1px solid #9ca3af',
            }}>
              <div>
                <div className="tw-flex tw-justify-between">
                  <h3 className="tw-text-white">Buyer</h3>
                  <img
                    src="/assets/images/3dcube.png"
                    alt="POD Pricing"
                    height={32}
                    width={32}
                    className="size-32px"
                  />
                </div>
                <p>
                  The buyer only pays for what they buy and
                  shipping
                </p>
              </div>

              <p className="h1 tw-inline-flex tw-items-center tw-gap-2">
                0% <span className="h5">per transaction</span>
              </p>

              <Button className="tw-w-full" href={'/buyer-signup'}>
                Start Shopping for Free
              </Button>
            </Card>

            <Card className="tw-space-y-4 !tw-border md:tw-space-y-8 tw-text-white" style={{
              border: '1px solid #9ca3af',
            }}>
              <div>
                <div className="tw-flex tw-justify-between">
                  <h3 className="tw-text-white">Seller</h3>
                  <img
                    src="/assets/images/3dcube.png"
                    alt="POD Pricing"
                    height={32}
                    width={32}
                    loading="lazy"
                    className="size-32px"
                  />
                </div>
                <p>Best for businesses owners and traders</p>
              </div>

              <p className="h1 tw-inline-flex tw-items-center tw-gap-2">
                2.97%{' '}
                <span className="h5">per transaction</span>
              </p>

              <Button className="tw-w-full" href={'/create-link'}>
                Start Selling Now
              </Button>
            </Card>
          </div>
        </Section>
      </div>

      <Section>
        <TestimonialSlider
          header="From Our Community..."
          slides={[
            {
              image: '/assets/images/shops/shop-thanau.png',
              name: 'Thanau Abbas',
              position: 'Shop thanau - POD seller',
              content: 'Our sales have grown significantly since we started selling with POD. The SecurePay service added a great layer of trust for our buyers. Selling ever since has been super easy, fast and reliable!'
            },
            {
              image: '/assets/images/shops/apos003s.jpeg',
              name: "Annistouch Beauty",
              position: 'POD seller',
              content: "This is so lovely and easy to use. Thanks so much. In short, you're the best! I was happy using the site for selling my goods. It was fast and swift and even my client likes the process."
            },
            {
              image: '/assets/images/shops/Tribe25Lagos.jpeg',
              name: "Tribe25Lagos",
              position: 'POD seller',
              content: "My customer has made payment and a rider has picked up the item for delivery. Really appreciate the prompt response."
            },
            {
              image: '/assets/images/shops/Swann.jpeg',
              name: "The Lady Swann",
              position: 'POD seller',
              content: "I've already used PayOnDelivery Nigeria and loved the experience. The seamless delivery arrangement took all the stress off my shoulders, which was fantastic!"
            },
            {
              image: '/assets/images/shops/apos001s.jpeg',
              name: "Blessed Monday",
              position: 'POD seller',
              content: "Yah because the time I started using POD, it was ok and fine and it's good for business users based on no scammer on the site."
            },
            {
              image: '/assets/images/shops/emmanuel.jpeg',
              name: 'Emmanuel Adesina',
              position: 'Shop platinum - POD seller',
              content: 'POD has transformed how I do business online. The escrow system gives my customers confidence to order, and the delivery integration makes fulfillment seamless. My business has seen 3x growth since joining POD!'
            },
            {
              image: '/assets/images/shops/Dammycriss.jpeg',
              name: "Dammycriss",
              position: 'POD seller',
              content: "This is quite impressive. Sounds like a sustainable plan and platform."
            },
            {
              image: '/assets/images/shops/Blessed.jpeg',
              name: "Blessed Monday",
              position: 'POD seller',
              content: "Yah because the time I started using POD, it was ok and fine and it's good for business users based on no scammer on the site."
            }
          ]}
        />
      </Section>

      <FAQ questions={faqs} />

      <Security />
    </App>
  );
}

